import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import ProfileHeroEditControls from './ProfileHeroEditControls';
import ProfileHeroEditControlsV2 from '../ProfileHeroEditControls.group_profiles';
import ProfileHeroEditControlsContainer from './ProfileHeroEditControls.container';

export default withFeatureBranch({ group_profiles: ProfileHeroEditControlsV2 })(
  ProfileHeroEditControlsContainer(ProfileHeroEditControls)
);
